import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { createUserReviewsEvent } from '@/scopes/products/user-reviews/infrastructure/analytics'
import { Button } from '@sunwebgroup/ui-components'
import React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export function ShowMoreReviewsButton() {
  const { showNextReviews, reviewPages } = useUserReviews()
  const { sendEvent } = useAnalytics()
  const intl = useIntl()

  const handleClick = async () => {
    await showNextReviews()
    sendEvent(
      createUserReviewsEvent({
        description: 'show more reviews',
        element: 'Button',
        result: `Many times clicked: ${reviewPages.length - 1} times`,
      }),
    )
  }

  return (
    <Wrapper>
      <Button $withoutColor onClick={handleClick}>
        {intl.formatMessage({ id: 'reviews_show_more_reviews' })}
      </Button>
    </Wrapper>
  )
}
